import { Box, Button, Stack, Tooltip } from "@mui/material"
import { InfoMensajeDesktop } from "../../../components/desktop/InfoMensajeDesktop"
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import CloseIcon from "@mui/icons-material/Close";
import SplitButton from "src/components/forms/SplitButton";
import { HeaderProps } from "../../OperacionLayout";
import SaveIcon from '@mui/icons-material/Save';

export const HeaderDesktop = ({ acciones, message }: HeaderProps) => {
    const { isNewOperacion, saveHandler, closeHandler, printHandler, actionsOptions, actionsHandler } = acciones

    return (
        <Box
            display='flex'
            justifyContent='space-between'
            alignItems='center'
            width='100%'
            maxWidth='100%'
            pb={6}
        >
            <InfoMensajeDesktop message={message} />
            <Stack direction='row' spacing={2}>
                {
                    saveHandler &&
                    <Tooltip title='Guardar operación'>
                        <Button
                            variant='outlined'
                            endIcon={<SaveIcon />}
                            onClick={saveHandler}
                        >
                            Guardar
                        </Button>
                    </Tooltip>
                }
                {
                    (actionsOptions && actionsOptions.length) ?
                        <SplitButton
                            options={actionsOptions}
                            onClick={actionsHandler}
                        /> : <></>
                }
                <Tooltip title='Generar informe'>
                    <Button
                        variant='contained'
                        color='primary'
                        onClick={printHandler}>
                        <SaveAltIcon />
                    </Button>
                </Tooltip>
                <Tooltip title='Liberar operación'>
                    <Button variant='contained' onClick={closeHandler} color='error'>
                        <CloseIcon />
                    </Button>
                </Tooltip>
            </Stack>
        </Box>
    )
}
